import { CommonModule } from '@angular/common';
import { Component, NgModule, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { ETipoAcesso, NavigationMenu, navigation } from 'src/app/app-navigation';

import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService, ITheme } from '../../services/auth.service';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-side-navigation-menu',
    templateUrl: './side-navigation-menu.component.html',
    styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements OnInit, OnDestroy {
    @ViewChild('drawer', { static: false }) drawer!: MatDrawer;

    rotas = navigation;
    theme: ITheme = 'light';
    rotasListar: NavigationMenu[] = [];
    currentRoute!: string;
    modoMenu: 'over' | 'side' = 'side';
    menuAberto = true;

    urlLogoHorizontal = environment.urlArquivosEstaticos + '/logo-horizontal.png';

    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    ngOnInit(): void {

        this.currentRoute = this.router.url.replace('/', '');

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: any) => {
                this.currentRoute = event.urlAfterRedirects.replace('/', '');
            });


        this.authService.themeSubject$.pipe().subscribe((theme) => {
            this.theme = theme;
            this.configurarLogoMenu();
        })

        this.authService.acessoSubject$.pipe().subscribe((acesso) => {
            this.listarRotasMenu();
        });

        this.configurarModoMenu();

        this.listarRotasMenu();
    }

    ngOnDestroy(): void {}

    toggleMenu() {
        this.drawer.toggle();
    }

    private configurarLogoMenu(){
        if(this.theme == 'light'){
            this.urlLogoHorizontal = environment.urlArquivosEstaticos + '/logo-horizontal.png';
        } else {
            this.urlLogoHorizontal = environment.urlArquivosEstaticos + '/branco-horizontal.png';
        }
    }

    private configurarModoMenu() {
        const tipoAcesso = this.authService.getTipoAcesso();
        if (tipoAcesso == ETipoAcesso.PESSOAL) {
            // menu sobreposto e inicia fechado
            this.menuAberto = true;
            this.modoMenu = 'side';
        } else {
            //verificar se é mobile para exibir menu sobreposto ou não
            if (this.isMobile()) {
                this.modoMenu = 'over';
                this.menuAberto = false;
            } else this.modoMenu = 'side';
        }
    }

    private isMobile() {
        return window.matchMedia('(max-width: 1000px)').matches;
    }

    private listarRotasMenu() {
        this.rotasListar = [];
        const tipoAcesso = this.authService.getTipoAcesso();

        if (!tipoAcesso) return;

        this.rotas.forEach((rota) => {
            const permissoes = rota.permissoes as string[];
            if (!permissoes || permissoes.includes(tipoAcesso)) {
                // se a rota não tiver permissoes
                // ou se o usuario possuir permissoes
                this.rotasListar.push(rota);
            }
        });
    }
}

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatSidenavModule,
        MatButtonModule,
        MatListModule,
        MatIconModule
    ],
    declarations: [SideNavigationMenuComponent],
    exports: [SideNavigationMenuComponent]
})
export class SideNavigationMenuModule {}
